import { LocalDateType } from '@app/models';
import { Agency, agencyBasic } from '@app/models/agency';
import { DictionaryEntity } from '@app/pcs/models/dictionary-entity';
import { ProcessType } from '@app/pcs/models/process-type';
import { TrafficLights } from '@app/pcs/models/traffic-lights';
import { TrainType } from '@app/pcs/models/train-type';
import { UserLabel,userLabel } from '@app/pcs/models/user-label';
import { LocalDateTime } from '@util/local-date-time';
import { gql } from 'apollo-angular';

export interface DossierObservation {
  involvedImIds: number[];
  observationTypes?: DictionaryEntity[];
}

export interface DossierSearchItem {
  ttpId: number;
  dossierId: number;
  title: string;
  internationalTrainNumber: string;
  papId?: string;
  trainNumber: string;
  trainType: TrainType;
  dossierStatuses: DictionaryEntity[];
  dossierType: DictionaryEntity;
  processType: ProcessType;
  carriedForward: boolean;
  lastChangeDate: LocalDateType;
  lastChangeAgency: Agency;
  lastReadVersion: number;
  version: number;
  trafficLights: TrafficLights[];
  labels: UserLabel[];
  observation: DossierObservation;
  route?: string;
  startDate?: LocalDateType;
  endDate?: LocalDateType;
  pathRequestLastDate?: LocalDateTime;
}

const dossierStatus = gql`
    fragment dossierStatus on DossierStatus {
        id
        description
     }`;

const trafficLight = gql`
    fragment trafficLight on TrafficLight {
        id
        agency {
            ...agencyBasic
            pathfinderMember
            unknownAgency
        }
        leadingAgency
        progressStatus {
            id
            description
        }
    }
    ${agencyBasic}
`;

export const dossierAdvancedSearchItem = gql`
    fragment dossierAdvancedSearchItem on DossierSearchItem {
        ttpId
        dossierId
        title
        internationalTrainNumber
        papId
        trainNumber
        trainType {
            id
            description
        }
        dossierStatuses {
           ... dossierStatus
        }
        dossierType {
            id
            description
        }
        processType {
            id
            description
        }
        carriedForward
        lastChangeDate
        lastChangeAgency {
            ...agencyBasic
        }
        lastReadVersion
        version
        trafficLights {
            applicant {
                ...trafficLight
            }
            im {
                ...trafficLight
            }
            coss {
                ...trafficLight
            }
        }
        labels {
            ...userLabel
        }
      observation {
        involvedImIds
        observationTypes {
          id
          description
        }

      }
      pathRequestLastDate
    }
    ${dossierStatus}
    ${agencyBasic}
    ${trafficLight}
    ${userLabel}
`;
